import { ESTADOS_DETALLE_SOLICITUD, ESTADOS_SOLICITUD, formatearValorAMoneda } from '../utils';
import ListadoAgGridMixin from './listado-ag-grid-mixin';

export default {
  mixins: [ListadoAgGridMixin],
  props: {
    sumasTotales: {
      type: Object,
      default: () => {
        return {
          [ESTADOS_DETALLE_SOLICITUD.PENDIENTE]: 0,
          [ESTADOS_DETALLE_SOLICITUD.APROBADO]: 0,
          [ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO]: 0,
          [ESTADOS_DETALLE_SOLICITUD.RECHAZADO]: 0,
          [ESTADOS_DETALLE_SOLICITUD.ANULADO]: 0,
        };
      },
    },
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'NRO.',
          field: 'numero',
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'FECHA SOLICITUD',
          field: 'created_at',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'SOLICITANTE',
          field: 'user',
          filter: true,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ESTADO SOLICITUD',
          filter: true,
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else if (param.data.estado == ESTADOS_SOLICITUD.SOLICITADO) {
              return /*html */ `<div class="pill pill-solicitado">${ESTADOS_SOLICITUD.SOLICITADO}</div>`;
            } else if (param.data.estado == ESTADOS_SOLICITUD.ATENDIDO) {
              return /*html */ `<div class="pill pill-atendido">${ESTADOS_SOLICITUD.ATENDIDO}</div>`;
            }
          },
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: '',
          field: 'detalle',
          filter: false,
          minWidth: 160,
          maxWidth: 160,
        },
        {
          headerName: 'TOTAL',
          field: 'total',
          type: 'numericColumn',
          valueFormatter: function (params) {
            return formatearValorAMoneda(params.value);
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
    };
  },
  computed: {
    pinnedBottomRowData() {
      return [
        {
          detalle: 'TOTAL PENDIENTE',
          // total: this.calcularTotalPorEstado(ESTADOS_DETALLE_SOLICITUD.PENDIENTE),
          total: this.sumasTotales[ESTADOS_DETALLE_SOLICITUD.PENDIENTE],
          bold: true,
        },
        {
          detalle: 'TOTAL APROBADO',
          // total: this.calcularTotalPorEstado(ESTADOS_DETALLE_SOLICITUD.APROBADO),
          total: this.sumasTotales[ESTADOS_DETALLE_SOLICITUD.APROBADO],
          bold: true,
        },
        // {
        //   detalle: 'TOTAL RECHAZADO',
        //   total: this.calcularTotalPorEstado(ESTADOS_DETALLE_SOLICITUD.RECHAZADO),
        //   bold: true,
        // },
        {
          detalle: 'TOTAL DESEMBOLSADO',
          // total: this.calcularTotalPorEstado(ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO),
          total: this.sumasTotales[ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO],
          bold: true,
        },
        // {
        //   detalle: 'TOTAL ANULADO',
        //   total: this.calcularTotalPorEstado(ESTADOS_DETALLE_SOLICITUD.ANULADO),
        //   bold: true,
        // },
        // {
        //   detalle: 'TOTAL FILTRADO',
        //   total: this.calcularTotalPorEstado(),
        //   bold: true,
        // },
        // {
        //   detalle: 'TOTAL',
        //   total: this.calcularTotal(),
        //   bold: true,
        // },
      ];
    },
  },
  created() {
    this.getRowStyle = (params) => {
      if (params.node.rowPinned) {
        if (params.node.data.bold) {
          return { 'font-weight': 'bold' };
        }
      }
    };
  },
  methods: {
    calcularTotalPorEstado(estado = ESTADOS_DETALLE_SOLICITUD.TODOS) {
      let resultado = 0;

      for (let index = 0; index < this.items.length; index++) {
        for (let i = 0; i < this.items[index].detalle_solicitud.length; i++) {
          if (estado == ESTADOS_DETALLE_SOLICITUD.TODOS) {
            resultado = resultado + parseFloat(this.items[index].detalle_solicitud[i].importe);
          } else if (this.items[index].detalle_solicitud[i].estado == estado) {
            resultado = resultado + parseFloat(this.items[index].detalle_solicitud[i].importe);
          }
        }
      }

      resultado = resultado.toFixed(2);

      return resultado;
    },
    calcularTotal() {
      let resultado = 0;

      for (let index = 0; index < this.items.length; index++) {
        resultado = resultado + parseFloat(this.items[index].total);
      }

      resultado = resultado.toFixed(2);

      return resultado;
    },
  },
};
